'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002ecomponents$002e$002dRecipe$002dViewer$0024$002dScale$002dBasis from "./mealorama.components.-Recipe-Viewer$-Scale-Basis.js";
var $p;
/** @constructor */
function $c_Lmealorama_components_RecipeViewer$ScaleBasis$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.ZI = null;
  this.ZI = \u03b4name$2;
}
export { $c_Lmealorama_components_RecipeViewer$ScaleBasis$$anon$1 as $c_Lmealorama_components_RecipeViewer$ScaleBasis$$anon$1 };
$p = $c_Lmealorama_components_RecipeViewer$ScaleBasis$$anon$1.prototype = new $j_mealorama$002ecomponents$002e$002dRecipe$002dViewer$0024$002dScale$002dBasis.$h_Lmealorama_components_RecipeViewer$ScaleBasis();
$p.constructor = $c_Lmealorama_components_RecipeViewer$ScaleBasis$$anon$1;
/** @constructor */
function $h_Lmealorama_components_RecipeViewer$ScaleBasis$$anon$1() {
}
export { $h_Lmealorama_components_RecipeViewer$ScaleBasis$$anon$1 as $h_Lmealorama_components_RecipeViewer$ScaleBasis$$anon$1 };
$h_Lmealorama_components_RecipeViewer$ScaleBasis$$anon$1.prototype = $p;
$p.q = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.r = (function() {
  return this.ZI;
});
$p.m = (function() {
  return this.ZI;
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I(this.ZI);
});
var $d_Lmealorama_components_RecipeViewer$ScaleBasis$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_components_RecipeViewer$ScaleBasis$$anon$1, "mealorama.components.RecipeViewer$ScaleBasis$$anon$1", ({
  I5: 1,
  I3: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1,
  n: 1,
  d: 1,
  e: 1,
  h: 1
}));
export { $d_Lmealorama_components_RecipeViewer$ScaleBasis$$anon$1 as $d_Lmealorama_components_RecipeViewer$ScaleBasis$$anon$1 };
//# sourceMappingURL=mealorama.components.-Recipe-Viewer$-Scale-Basis$$anon$1.js.map
